import React from "react";
import StaffLogin from "./StaffLogin";

export default function TelehealthReviewLogin() {
  return (
    <StaffLogin
      role="telehealth_clinician"
      storageKey="telehealthReviewer"
      dashboardPath="/telehealth-review-dashboard"
      badge="CLINICIAN ACCESS"
      title="Telehealth Review"
    />
  );
}
